import React, { useState } from 'react';
import { Button } from './ui/button';
import { ArrowRight, Loader2, Check } from 'lucide-react';

const LEAD_API_URL = 'https://api.worksuite.cl/v1/crm-capture-lead';
const LEAD_API_KEY = 'sb_publishable_pikt-oExOFtm-ZaozkAwaQ_qKqqyb91';
const LEAD_ORG_ID = '69d8e0bb-ed36-43c1-9416-d794e7f75ee0';

const INITIAL = { name: '', email: '', company: '' };

const CTASection = () => {
  const [formData, setFormData] = useState(INITIAL);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState(null); // 'success' | 'error' | null

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus(null);

    try {
      const res = await fetch(LEAD_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          apikey: LEAD_API_KEY
        },
        body: JSON.stringify({
          ...formData,
          org_id: LEAD_ORG_ID,
          source: 'webhook',
          source_detail: 'Landing principal - CTA Home'
        })
      });

      if (!res.ok) throw new Error('Bad response');

      setStatus('success');
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'conversion_event_submit_lead_form');
      }
      setFormData(INITIAL);
    } catch (err) {
      console.error(err);
      setStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-32 bg-black relative overflow-hidden" data-testid="home-cta-section">
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <div className="absolute top-10 -left-20 w-96 h-96 bg-green-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 -right-20 w-96 h-96 bg-blue-500 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-5xl sm:text-6xl font-bold text-white mb-6">
            Prueba Cloudbase Gratis
          </h2>
          <p className="text-xl text-gray-300 mb-10 font-light">
            Déjanos tus datos y agendamos una demo personalizada para tu negocio en 24 horas.
          </p>

          {status === 'success' ? (
            <div
              className="mx-auto max-w-2xl bg-green-600/10 border border-green-500/30 rounded-lg p-8"
              data-testid="home-cta-success"
            >
              <div className="flex items-center justify-center gap-3 mb-2">
                <Check className="w-6 h-6 text-green-400" />
                <p className="text-xl font-semibold text-white">¡Gracias! Te contactaremos pronto.</p>
              </div>
              <p className="text-gray-400 text-sm">
                Un ejecutivo se pondrá en contacto contigo en las próximas 24 horas hábiles.
              </p>
            </div>
          ) : (
            <form
              id="home-lead-form"
              onSubmit={handleSubmit}
              className="max-w-3xl mx-auto"
              data-testid="home-cta-form"
            >
              <div className="grid md:grid-cols-3 gap-3 mb-4">
                <input
                  type="text"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  placeholder="Nombre completo *"
                  className="px-5 py-4 bg-white/5 border border-white/20 text-white placeholder:text-gray-400 rounded focus:outline-none focus:ring-2 focus:ring-green-500 disabled:opacity-50"
                  data-testid="home-cta-name"
                />
                <input
                  type="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  placeholder="Email *"
                  className="px-5 py-4 bg-white/5 border border-white/20 text-white placeholder:text-gray-400 rounded focus:outline-none focus:ring-2 focus:ring-green-500 disabled:opacity-50"
                  data-testid="home-cta-email"
                />
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  placeholder="Empresa"
                  className="px-5 py-4 bg-white/5 border border-white/20 text-white placeholder:text-gray-400 rounded focus:outline-none focus:ring-2 focus:ring-green-500 disabled:opacity-50"
                  data-testid="home-cta-company"
                />
              </div>

              <Button
                type="submit"
                size="lg"
                disabled={isSubmitting}
                className="bg-green-600 hover:bg-green-700 text-white px-10 py-7 text-base rounded font-semibold transition-all duration-200 inline-flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                data-testid="home-cta-submit"
              >
                {isSubmitting ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin" />
                    Enviando...
                  </>
                ) : (
                  <>
                    Solicitar Demo Gratuita
                    <ArrowRight className="w-5 h-5" />
                  </>
                )}
              </Button>

              {status === 'error' && (
                <p className="mt-4 text-sm text-red-400" data-testid="home-cta-error">
                  Ocurrió un error al enviar. Intenta nuevamente o escríbenos a soporte@cloudbase.cl.
                </p>
              )}

              <p className="mt-6 text-xs text-gray-500">
                ¿Prefieres un formulario completo?{' '}
                <a href="/demo" className="text-green-400 hover:text-green-300 underline">
                  Ir a /demo
                </a>
              </p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default CTASection;
